import { render } from "./editPassword.vue?vue&type=template&id=6adf8f56&scoped=true"
import script from "./editPassword.vue?vue&type=script&lang=js"
export * from "./editPassword.vue?vue&type=script&lang=js"

import "./editPassword.vue?vue&type=style&index=0&id=6adf8f56&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adf8f56"]])

export default __exports__